// Ferment-Auswahl: Jede Kachel blendet die Section mit passendem data-ferment-panel ein
// (z. B. ein Set-Vergleich), alle anderen Panels aus. So bleiben die Inhalte eigenständige
// Sections und es gibt keine doppelten Daten.
class LpFermentTabs extends HTMLElement {
  connectedCallback() {
    this.tabs = [...this.querySelectorAll('[data-ferment-tab]')];
    this.panels = [...document.querySelectorAll('[data-ferment-panel]')].map((panel) => ({
      key: panel.dataset.fermentPanel,
      section: panel.closest('.shopify-section') || panel,
    }));

    this.tabs.forEach((tab) => tab.addEventListener('click', () => this.select(tab.dataset.fermentTab)));

    if (window.Shopify?.designMode) return;
    const requested = new URLSearchParams(window.location.search).get('ferment');
    const initial = this.tabs.some((tab) => tab.dataset.fermentTab === requested) ? requested : this.tabs[0]?.dataset.fermentTab;
    this.select(initial);
    this.preloadHiddenPanels();
  }

  // Bilder ausgeblendeter Panels würden per loading="lazy" erst beim Umschalten laden.
  // Nach dem Seitenaufbau im Leerlauf vorladen, damit der Wechsel ohne Nachladen klappt.
  preloadHiddenPanels() {
    const preload = () =>
      this.panels.forEach((panel) =>
        panel.section.querySelectorAll('img[loading="lazy"]').forEach((img) => {
          img.loading = 'eager';
        })
      );
    const whenIdle = () => ('requestIdleCallback' in window ? requestIdleCallback(preload) : setTimeout(preload, 1000));
    if (document.readyState === 'complete') {
      whenIdle();
    } else {
      window.addEventListener('load', whenIdle, { once: true });
    }
  }

  select(key) {
    this.tabs.forEach((tab) => tab.setAttribute('aria-pressed', String(tab.dataset.fermentTab === key)));
    this.panels.forEach((panel) => {
      panel.section.hidden = panel.key !== key;
    });
  }
}

if (!customElements.get('lp-ferment-tabs')) customElements.define('lp-ferment-tabs', LpFermentTabs);
